<template>
  <div class="body">
    <div class="bg-white p20">
      <!--培训课件  -->
      <div class="f--c mb20">
        <h2>
          课件信息
          <span class="required">*</span>
        </h2>
        <div class="hr"></div>
      </div>

      <el-form ref="form" :rules="rules" :model="form" label-width="80px">
        <el-row>
          <el-col :span="6" class="pr20">
            <el-form-item label="课件名称" prop="dataName" class="item">
              <el-input v-model="form.dataName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="行业类别" prop="professionalCategory">
              <dictionarySelect ref="dictionarySelect" :parentCode="$const.dictionary.TRAINING_INDUSTRY" :filter="true"
                                @submit="professionalCategorySubmitHandle" clearable></dictionarySelect>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="目录" prop="questionsDirectoryId">
              <selectTree
                :props="{
                                    value: 'id', // ID字段名
                                    label: 'directoryName', // 显示名称
                                    children: 'directoryList', // 子级字段名
                                }"
                :options="catalogList"
                :value="form.questionsDirectoryId"
                @getValue="directoryChange"
              ></selectTree>
              <!-- <el-select
  v-model="form.questionsDirectoryId"
  placeholder="请选择"
>
  <el-option
    v-for="(item, index) in catalogList"
    :key="index"
    :label="item.directoryName"
    :value="item.id"
  ></el-option>
</el-select> -->
            </el-form-item>
          </el-col>
          <!--          <el-col :span="6" class="pr20">-->
          <!--            <el-form-item label="部门" prop="departmentId">-->
          <!--              <selectTree-->
          <!--                ref="selectTree"-->
          <!--                :props="{-->
          <!--                  value: 'id', // ID字段名-->
          <!--                  label: 'text', // 显示名称-->
          <!--                  children: 'children' // 子级字段名-->
          <!--                }"-->
          <!--                :options="deptTree"-->
          <!--                :value="form.departmentId"-->
          <!--                @getValue="deptChange"-->
          <!--              ></selectTree>-->
          <!--              &lt;!&ndash; <el-select v-model="form.departmentId" placeholder="请选择">-->
          <!--                <el-option-->
          <!--                  v-for="item in departmentList"-->
          <!--                  :key="item.id"-->
          <!--                  :label="item.deptName"-->
          <!--                  :value="item.id"-->
          <!--                ></el-option>-->
          <!--              </el-select> &ndash;&gt;-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
        </el-row>
        <el-row class="mb20">
          <!--          <el-col :span="6" class="pr20">-->
          <!--            <el-form-item label="总学习人数" prop="studyUserCount" class="item">-->
          <!--              <el-input-number type="number" v-model="form.studyUserCount" :min="0" :max="100000" :step="1"></el-input-number>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <!--          <el-col :span="6" class="pr20">-->
          <!--            <el-form-item label="总点击次数" prop="clickUserCount">-->
          <!--              <el-input-number type="number" v-model="form.clickUserCount" :min="0" :max="100000" :step="1"></el-input-number>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <el-col :span="6" class="pr20">
            <el-form-item label="过期天数" prop="expireDay">
              <el-input-number type="number" v-model="form.expireDay" :min="1" :max="1000" :step="1"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="总价格" prop="dataPrice">
              <el-input-number type="number" v-model="form.dataPrice" :min="0" :max="100000"
                               :step="1"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="mb20">
          <el-col :span="6" class="pr20">
            <el-form-item label="教师名称" prop="teacherName" class="item">
              <el-input v-model="form.teacherName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="pr20">
            <el-form-item label="课件简介" prop="dataIntroduction">
              <el-input type="textarea" v-model="form.dataIntroduction"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!--培训课件  -->
        <div class="f--c mb20">
          <h2>
            课件附件
            <span class="required">*</span>
          </h2>
          <div class="hr"></div>
        </div>

        <el-button type="primary" icon="el-icon-plus" @click="addResource">新增</el-button>

        <el-table :data="tableData" style="width: 100%;margin:20px 0px;">
          <el-table-column prop="resourcesName" label="培训资源名称">
            <template slot-scope="scope">
              <el-input v-model="scope.row.resourcesName" placeholder="请输入"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="suggestedDuration" label="建议时长(分钟)" align="center">
            <template slot-scope="scope">
              <template v-if="scope.row.suggestedDurationMax">
                <el-input-number v-model="scope.row.suggestedDuration" :min="1" :max="scope.row.suggestedDurationMax"
                                 label="请输入资料学习时长（单位：分钟）"></el-input-number>
              </template>
              <template v-else>
                <el-input-number v-model="scope.row.suggestedDuration" :min="1"
                                 label="请输入资料学习时长（单位：分钟）"></el-input-number>
              </template>
            </template>
          </el-table-column>
          <!--          <el-table-column prop="expireDay" label="过期时间(单位:天)" align="center">-->
          <!--            <template slot-scope="scope">-->
          <!--              -->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column label="附件" width="400px" align="center">
            <template slot-scope="scope">
              <template type="success" v-if="scope.row.resourcesPath">
                <span v-if="scope.row.resourcesType == 1"
                      v-html="'视频文件' + (scope.row.suggestedDurationMax ? ',时长' + scope.row.suggestedDurationMax + '分钟' : '')"></span>
                <span v-else>
                                    PDF文件
                                </span>
              </template>
              <div v-else @click="selectTableIndex(scope.$index)">
                <el-upload-e :dir="ossConstant.dir.courseware" @onBefore="uploadBefore" @onSuccess="uploadSuccess"
                             :accept="'.mp4,.pdf'"></el-upload-e>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="success" v-if="scope.row.resourcesPath"
                         @click="preview(scope.row.resourcesUrl, scope.row.resourcesType)">预览
              </el-button>

              <el-button type="danger" @click="delResource(scope.row.resourcesFileId, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!--        &lt;!&ndash;关联考试  &ndash;&gt;-->
        <!--        <div class="f&#45;&#45;c mb20">-->
        <!--          <h2>关联考试</h2>-->
        <!--          <div class="hr"></div>-->
        <!--        </div>-->
        <!--        <el-button-->
        <!--          type="primary"-->
        <!--          icon="el-icon-plus"-->
        <!--          @click="showCorrelationExam"-->
        <!--        >关联考试-->
        <!--        </el-button-->
        <!--        >-->
        <!--        <el-table :data="dataList3" style="width: 100%;margin:20px 0px;">-->
        <!--          <el-table-column-->
        <!--            prop="questionsPaperName"-->
        <!--            label="试卷名称"-->
        <!--          ></el-table-column>-->
        <!--          <el-table-column label="试卷类型">-->
        <!--            <template slot-scope="scope">{{-->
        <!--                scope.row.selectionMode == 0 ? "随机试卷" : "固定试卷"-->
        <!--              }}-->
        <!--            </template>-->
        <!--          </el-table-column>-->
        <!--          <el-table-column-->
        <!--            prop="questionNumber"-->
        <!--            label="包含题目数量"-->
        <!--          ></el-table-column>-->
        <!--        </el-table>-->
        <!--        &lt;!&ndash; 关联考试 &ndash;&gt;-->
        <!--        <el-dialog-->
        <!--          title="关联考试"-->
        <!--          :visible.sync="isShowCorrelationExam"-->
        <!--          width="70%"-->
        <!--        >-->
        <!--          <el-form-->
        <!--            ref="correlationExamFormRef"-->
        <!--            :model="correlationExamForm"-->
        <!--            label-width="80px"-->
        <!--          >-->
        <!--            <el-row>-->
        <!--              <el-col :span="12">-->
        <!--                <el-form-item label="试卷名称" prop="questionsPaperName">-->
        <!--                  <el-input-->
        <!--                    :disabled="$route.query.type == 'check'"-->
        <!--                    v-model="correlationExamForm.questionsPaperName"-->
        <!--                  ></el-input>-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--              <el-col :span="1">-->
        <!--                <div style="height:1px;"></div>-->
        <!--              </el-col>-->
        <!--              <el-col :span="12">-->
        <!--                <el-form-item label="试卷类型" prop="selectionMode">-->
        <!--                  <el-select v-model="correlationExamForm.selectionMode">-->
        <!--                    <el-option label="固定试卷" value="1"></el-option>-->
        <!--                  </el-select>-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--            </el-row>-->

        <!--            <el-row>-->
        <!--              <el-col :span="12">-->
        <!--                <el-form-item label="是否开卷" prop="openBook" class="item">-->
        <!--                  <el-select v-model="correlationExamForm.openBook">-->
        <!--                    <el-option label="开卷" value="0"></el-option>-->
        <!--                    <el-option label="闭卷" value="1"></el-option>-->
        <!--                  </el-select>-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--              <el-col :span="1">-->
        <!--                <div style="height:1px;"></div>-->
        <!--              </el-col>-->
        <!--              <el-col :span="12">-->
        <!--                <el-form-item>-->
        <!--                  <el-button type="primary" @click="getPaperList">搜索</el-button>-->
        <!--                  <el-button-->
        <!--                    type="primary"-->
        <!--                    @click="resetForm('correlationExamFormRef')"-->
        <!--                  >重置-->
        <!--                  </el-button-->
        <!--                  >-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--            </el-row>-->
        <!--          </el-form>-->
        <!--          &lt;!&ndash; 试卷列表 &ndash;&gt;-->
        <!--          <el-table :data="paperList" @selection-change="selectionChange2">-->
        <!--            <el-table-column type="selection"></el-table-column>-->
        <!--            <el-table-column-->
        <!--              property="questionsPaperName"-->
        <!--              label="试卷名称"-->
        <!--            ></el-table-column>-->
        <!--            <el-table-column property="name" label="试卷类型">-->
        <!--              <template slot-scope="scope">{{-->
        <!--                  scope.row.selectionMode == 0 ? "随机试卷" : "固定试卷"-->
        <!--                }}-->
        <!--              </template>-->
        <!--            </el-table-column>-->
        <!--            <el-table-column-->
        <!--              property="department"-->
        <!--              label="所属部门"-->
        <!--            ></el-table-column>-->
        <!--            <el-table-column-->
        <!--              property="questionNumber"-->
        <!--              label="包含题目数量"-->
        <!--            ></el-table-column>-->
        <!--            <el-table-column label="是否开卷">-->
        <!--              <template slot-scope="scope">{{-->
        <!--                  scope.row.openBook == 0 ? "开卷" : "闭卷"-->
        <!--                }}-->
        <!--              </template>-->
        <!--            </el-table-column>-->
        <!--          </el-table>-->
        <!--          <el-pagination-->
        <!--            style="margin-top:20px;"-->
        <!--            background-->
        <!--            layout="prev, pager, next"-->
        <!--            :total="total2"-->
        <!--            :page-size="pageSize2"-->
        <!--            @current-change="pageChange2"-->
        <!--          ></el-pagination>-->
        <!--          &lt;!&ndash;  &ndash;&gt;-->
        <!--          <span slot="footer" style="float:right;" class="p10">-->
        <!--        <el-button @click="isShowCorrelationExam = false">取 消</el-button>-->
        <!--        <el-button type="primary" @click="confirm2">确 定</el-button>-->
        <!--      </span>-->
        <!--        </el-dialog>-->

        <div class="searchBut">
          <el-button type="primary" @click="save" :loading="saveLoading">保存</el-button>
          <el-button type="primary" @click="$router.back(-1)">返回</el-button>
        </div>
      </el-form>
    </div>

    <el-dialog title="预览" :visible.sync="dialogVisible" width="80%" modal @close="previewDialogClose()">
      <div style="width:100%;height:100%;padding:100px;" class="f-c-c">
        <trainingVideo ref="trainingVideo" :sourceUrl="resourcePath"></trainingVideo>
        <!--        <video :src="resourcePath" controls></video>-->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api/mall/training.js";
import api_dept from "@/api/api_dept.js";
import exam from "@/api/mall/exam.js";
import selectTree from "@/components/common/selectTree";
import trainingVideo from "@/components/training/trainingVideo";
import elUploadE from "@/components/common/oss/ossUploadMultiple";
import ATT_API from "@/api/api_att";
import $const from "@/common/constant";
import dictionarySelect from "@/components/common/dictionarySelect";
import $ossConstant from "@/components/common/oss/ossConstant";

export default {
  components: {selectTree, elUploadE, trainingVideo, dictionarySelect},
  data() {
    return {
      $const: $const,
      ossConstant: $ossConstant,
      id: 0,
      form: {
        dataName: "",
        dataIntroduction: "",

        professionalCategoryName: "", // 专业类别名称
        professionalCategory: "", // 专业类别
        professionalCategoryItem: "",
        professionalCategorySubItem: "",

        department: "", //部门
        // departmentId: "", // 部门id
        questionsDirectoryId: "",
        teacherName: undefined,
        studyUserCount: "",
        clickUserCount: "",
        dataPrice: 0,
        expireDay: 0,
      },
      rules: {
        dataName: [{required: true, message: "请输入课件名称", trigger: "blur"}],
        dataIntroduction: [{required: true, message: "请输入课件简介", trigger: "blur"}],
        // professionalCategory: [
        //   {required: true, message: "请输入专业类别", trigger: "blur"}
        // ],
        // departmentId: [
        //   { required: true, message: "请选择部门", trigger: "blur" }
        // ],
        questionsDirectoryId: [{required: true, message: "请选择目录", trigger: "blur"}],
        teacherName: [{required: true, message: "教师名不能为空", trigger: "blur"}],
        expireDay: [{required: true, message: "过期时间不能为空", trigger: "blur"}],
        dataPrice: [{required: true, message: "总价格不能为空", trigger: "blur"}],
      },
      tableData: [],
      departmentList: [], //部门列表
      categoryList: [],
      resourcePath: "", // 资源路径
      dialogVisible: false,
      catalogList: [],
      selectCatalogue: {},

      uploadUrl: "",
      headers: {
        Authorization: "",
      },
      deptTree: [],
      dept: {},

      isShowCorrelationExam: false,
      page2: 1,
      pageSize2: 20,
      total2: 0,
      correlationExamForm: {
        openBook: undefined,
        selectionMode: undefined,
        questionsPaperName: undefined,
      },
      selectPaperList: [],
      dataList3: [],
      saveLoading: false,
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDataDetail();
    this.getDepartmentList();
    this.getCatalogList();

    this.uploadUrl = process.env.API_ROOT + "/clouddo-tranning/training/resources/data/upload";
    this.headers.Authorization = window.localStorage.getItem("access-token");
    this.deptTree = JSON.parse(localStorage.getItem("deptTree"));

    this.categoryList = JSON.parse(localStorage.getItem("categoryList"));
  },
  methods: {
    clearProfessionalCategory() {
      this.form.professionalCategory = undefined;
      this.form.professionalCategoryItem = undefined;
      this.form.professionalCategorySubItem = undefined;
    },
    professionalCategorySubmitHandle(data) {
      this.clearProfessionalCategory();
      if (data) {
        this.form.professionalCategoryName = data.pathTextName;
        this.buildProfessionalCategory(data.node);
      }
    },
    buildProfessionalCategory(node) {
      if (node.level == 1) {
        this.form.professionalCategory = node.data.object.code;
      }
      if (node.level == 2) {
        this.form.professionalCategoryItem = node.data.object.code;
      }
      if (node.level == 3) {
        this.form.professionalCategorySubItem = node.data.object.code;
      }
      if (node.parent) {
        this.buildProfessionalCategory(node.parent);
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    directoryChange(v) {
      this.selectCatalogue = v;
      this.form.questionsDirectoryId = v.id;
    },
    deptChange(v) {
      this.dept = v;
      this.form.departmentId = v.id;
    },
    getCatalogList() {
      exam.getCatalogList({
        type: 3,
        // enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
        //   .enterpriseId
      }).then((res) => {
        this.catalogList = res.data;
      });
    },
    //获取部门列表
    getDepartmentList() {
      this.departmentList = JSON.parse(localStorage.getItem("departmentList"));
    },
    /**
     * 培训课件单条详情
     */
    getDataDetail() {
      if (!this.id) return;
      api.getDataDetail({
        dataId: this.id,
      }).then((res) => {
        this.form.dataName = res.data.dataName;
        this.form.dataIntroduction = res.data.dataIntroduction;
        this.form.dataName = res.data.dataName;
        this.form.professionalCategory = res.data.professionalCategory; // 专业类别
        this.form.professionalCategoryItem = res.data.professionalCategoryItem;
        this.form.professionalCategorySubItem = res.data.professionalCategorySubItem;
        this.form.professionalCategoryName = res.data.professionalCategoryName;
        this.form.department = res.data.department;
        // this.form.departmentId = Number(res.data.departmentId);
        this.form.questionsDirectoryId = res.data.questionsDirectoryId;
        this.form.teacherName = res.data.teacherName;
        this.form.clickUserCount = res.data.clickUserCount;
        this.form.studyUserCount = res.data.studyUserCount;
        this.form.dataPrice = res.data.dataPrice ? res.data.dataPrice : "0";
        this.form.expireDay = res.data.expireDay ? res.data.expireDay : "0";

        if (res.data.professionalCategoryCheckValue) {
          this.$refs.dictionarySelect.setChecked(res.data.professionalCategoryCheckValue, res.data.professionalCategoryName);
        }

        this.tableData = res.data.trainingResourcesDetailVos;
        if (res.data.joinPaperVos) {
          this.dataList3 = res.data.joinPaperVos;
          this.dataList3.forEach((t) => {
            t.questionNumber = t.questionsNumber;
          });
        }
      });
    },
    save() {
      this.$refs.form.validate((validate) => {
        if (validate == false) return;

        if (
          !this.form.dataName ||
          !this.form.dataIntroduction ||
          !this.form.questionsDirectoryId
          // !this.form.professionalCategory
        )
          return this.$message.error("请完善课件信息");
        if (this.tableData.length > 0) {
          let data = this.tableData[this.tableData.length - 1];
          if (!data.resourcesName || !data.resourcesPath || !data.suggestedDuration) {
            return this.$message.error("请完善表格信息");
          }
        } else {
          return this.$message.error("请新增课件附件");
        }
        if (this.tableData) {
          for (let i = 0; i < this.tableData.length; i++) {
            let obj = this.tableData[i];
            console.log(obj.suggestedDurationMax && obj.suggestedDurationMax < obj.suggestedDuration);
            if (obj.suggestedDurationMax && obj.suggestedDurationMax < obj.suggestedDuration) {
              return this.$message.error("附件视频【" + obj.resourcesName + "】 建议时长不能超过视频本身时长。最大只能填【" + obj.suggestedDurationMax + "】分钟");
              return;
            }
          }
          this.tableData.forEach(function (item) {
            delete item.resourcesUrl;
          });
        }
        let p = {
          dataName: this.form.dataName,
          teacherName: this.form.teacherName, // 教师名称
          dataIntroduction: this.form.dataIntroduction,

          professionalCategoryName: this.form.professionalCategoryName,
          professionalCategory: this.form.professionalCategory,
          professionalCategoryItem: this.form.professionalCategoryItem,
          professionalCategorySubItem: this.form.professionalCategorySubItem,

          clickUserCount: this.form.clickUserCount,
          studyUserCount: this.form.studyUserCount,
          questionsDirectoryId: this.form.questionsDirectoryId,
          dataPrice: this.form.dataPrice,
          expireDay: this.form.expireDay,
          trainingResourcesSaveDtos: this.tableData,
          // enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
        };
        if (this.id) p.id = this.id;

        if (p.questionsDirectoryId) {
          p.questionsDirectoryName = this.selectCatalogue.text;
          // this.catalogList.forEach(v => {
          //   if (v.id == p.questionsDirectoryId) {
          //     p.questionsDirectoryName = v.directoryName;
          //   }
          // });
        }
        // p.department = this.departmentList.filter((v, i) => {
        //   return v.id == this.form.departmentId;
        // })[0].deptName;
        p.department = this.dept.text;
        //关联试卷
        p.joinPaperSaveDtos = [];
        this.dataList3.forEach((v) => {
          p.joinPaperSaveDtos.push({
            questionsPaperId: v.id || v.questionsPaperId,
            questionsPaperName: v.questionsPaperName,
            questionsPaperType: v.selectionMode !== undefined ? v.selectionMode : v.questionsPaperType,
            questionsNumber: v.questionNumber !== undefined ? v.questionNumber : v.questionNumber,
          });
        });
        this.saveLoading = true;
        api.postData(p).then((res) => {
          if (res.code == 0) {
            this.$message.success("成功");
            this.$router.go(-1);
          } else {
            this.saveLoading = false;
            this.$message.error(res.message);
          }
        });
      });
    },
    addResource() {
      if (this.tableData.length == 0) {
        this.tableData.push({
          resourcesName: "",
          resourcesPath: "",
          // resourcesType: 1, // 0:pdf,1:视频
          suggestedDuration: "", // 建议时长
        });
      } else {
        let data = this.tableData[this.tableData.length - 1];
        if (!data.resourcesName || !data.resourcesPath || !data.suggestedDuration) {
          return this.$message.error("请完善表格信息再新增数据");
        }

        this.tableData.push({
          resourcesName: "",
          resourcesPath: "",
          resourcesUrl: "",
          suggestedDuration: "", // 建议时长
        });
      }
    },
    /**
     * 预览视频或pdf
     * resourcesType: 0:pdf,  1:视频
     */
    preview(resourcePath, resourcesType) {
      if (resourcesType == 1) {
        this.resourcePath = resourcePath.indexOf("http") > -1 ? resourcePath : "http://" + resourcePath;
        this.dialogVisible = true;
      } else {
        window.open(resourcePath.indexOf("http") > -1 ? resourcePath : "http://" + resourcePath);
      }
    },
    /**
     * 当预览弹出关闭时
     **/
    previewDialogClose() {
      //暂停视频
      this.$refs.trainingVideo.pause();
    },
    /**
     * 删除资源
     */
    delResource(resourcesFileId, index) {
      this.tableData.splice(index, 1);
      if (!resourcesFileId) return;
      ATT_API.delAttByIds({
        ids: resourcesFileId,
      }).then((res) => {
        this.$message.error(res.message);
      });
    },

    /**
     * 获取时长度
     */
    getTimes(file) {
      let content = file;
      let url = URL.createObjectURL(content);
      let audioElement = new Audio(url);
      audioElement.addEventListener("loadedmetadata", (_event) => {
        let num = Math.floor(audioElement.duration / 60) > 0? Math.floor(audioElement.duration / 60) : 1;
        this.tableData[this.tableIndex].suggestedDuration = num;
        this.tableData[this.tableIndex].suggestedDurationMax  = num;
      });
    },
    /**
     * 上传之前
     **/
    uploadBefore(file) {
      let fileType = file.name
        .split(".")
        .pop()
        .toLowerCase();
      if (fileType == "mp4") {
        this.getTimes(file);
      }
    },
    /**
     * 上传文件成功回调
     */
    uploadSuccess(e, data) {
      this.tableData[this.tableIndex].resourcesUrl = data.url;
      this.tableData[this.tableIndex].resourcesPath = data.name;
      // this.tableData[this.tableIndex].resourcesFileId = data.hash
      if (data.name.indexOf(".pdf") > -1 || data.name.indexOf(".PDF") > -1) {
        this.tableData[this.tableIndex].resourcesType = 0;
      } else {
        this.tableData[this.tableIndex].resourcesType = 1;
      }
    },
    selectTableIndex(index) {
      this.tableIndex = index;
    },
    //
    selectChange(departmentId, department) {
      console.log(arguments);
    },
    // 关联考试相关方法
    showCorrelationExam() {
      this.isShowCorrelationExam = true;
      this.getPaperList();
    },
    getPaperList() {
      let p = {
        ...this.correlationExamForm,
        page: this.page,
        pageSize: this.pageSize,
        // enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      };
      exam.getPaperList(p).then((res) => {
        this.paperList = res.data.records;
        this.total2 = res.data.total;
      });
    },
    // 关联考试,确定
    confirm2() {
      this.selectPaperList.forEach((v) => {
        this.dataList3.forEach((v2) => {
          if (v.id == v2.id || v.id == v2.questionsPaperId) {
            this.isShowCorrelationExam = false;
            throw "已经存在";
          }
        });
      });

      this.selectPaperList.forEach((v) => {
        this.dataList3.push(v);
      });
      this.isShowCorrelationExam = false;
    },
    selectionChange2(e) {
      this.selectPaperList = e;
    },
  },
};
</script>

<style lang="scss">
.el-form-item__label {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/mall/trainingManagement/trainingResourceDetail.vue